import * as AdvancedSearchConfig from './advancedSearchConfig';
import * as BoostRule from './boostRule';
import * as FacetSearchConfig from './facetSearchConfig';
import * as IndexConfig from './indexConfig';
import * as IndexedProperty from './indexedProperty';
import * as Index from './indexEntity';
import * as PromotedItem from './promotedItem';
import * as ServerConfig from './serverConfig';
import * as Server from './server';
import * as SortField from './sortField';
import * as StopWord from './stopWord';
import * as Synonym from './synonym';
import * as ValueRange from './valueRange';
import * as ValueRangeSet from './valueRangeSet';
import * as SearchConfig from './searchConfig';
import * as Sort from './sort';
import * as Search from './search';

export default {
  ServerConfig,
  FacetSearchConfig,
  Server,
  AdvancedSearchConfig,
  BoostRule,
  IndexConfig,
  IndexedProperty,
  Index,
  PromotedItem,
  SortField,
  StopWord,
  Synonym,
  ValueRange,
  ValueRangeSet,
  SearchConfig,
  Sort,
  Search,
};
